import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField, Button } from '@mui/material'
import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form'

function CustomerDialog({ customer, open, onClose, onSubmit }) {
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm({
        defaultValues: { name: '' }, // Default value for form fields
    })

    // Update form values when customer changes or dialog opens
    useEffect(() => {
        if (open) {
            reset(customer ? { name: customer.name } : { name: '' })
        }
    }, [customer, open, reset])

    const handleFormSubmit = (data) => {
        onSubmit(data)
        reset() // Reset form after submission
    }

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{customer ? 'Redigera kund' : 'Skapa ny kund'}</DialogTitle>
            <DialogContent>
                <DialogContentText>{customer ? 'Redigera kundens uppgifter' : 'Ange kundens namn'}</DialogContentText>
                <form onSubmit={handleSubmit(handleFormSubmit)}>
                    <input type='hidden' {...register('id')} value={customer?.id || ''} />
                    {/* Name Field */}
                    <TextField
                        autoFocus
                        margin='dense'
                        label='Namn'
                        type='text'
                        fullWidth
                        {...register('name', { required: 'Namn krävs' })}
                        error={!!errors.name}
                        helperText={errors.name ? errors.name.message : ''}
                    />

                    <DialogActions>
                        <Button onClick={onClose} color='primary'>
                            Avbryt
                        </Button>
                        <Button type='submit' color='primary' variant='contained'>
                            {customer ? 'Spara' : 'Skapa'}
                        </Button>
                    </DialogActions>
                </form>
            </DialogContent>
        </Dialog>
    )
}

export default CustomerDialog
